export default function proxyComponent(Component, implementation) {
  function Proxy(props) {
    return implementation(props);
  }

  Proxy.displayName = 'Proxy(' + (Component.displayName || Component.name) + ')';

  return Proxy;
}
